/**
 *
 * BuildingPickerFilter
 *
 */
import { BuildingPicker } from 'app/components/pickers/AutocompletePickers/BuildingPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const BuildingPickerFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <BuildingPicker
      onChange={handleOnChange}
      value={props.value}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      size="small"
      ariaLabel={props.label}
      id={props.id}
      predicates={props.predicates}
      onPickerOpen={props.onOpen}
      urlType={props.urlType}
      withoutServiceGroups={props.withoutServiceGroups}
    />
  );
};
